module.exports = __webpack_public_path__ + "static/media/Roboto-ThinItalic.b417992b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-ThinItalic.woff2
// module id = 516
// module chunks = 0